module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon11.7a340f84.png";